import React from "react";

const DarkTheme = () => {
  return (
    <svg
      aria-hidden={true}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M8 2C8.79565 2.79565 9.24264 3.87478 9.24264 5C9.24264 6.12522 8.79565 7.20435 8 8C7.20435 8.79565 6.12522 9.24264 5 9.24264C3.87478 9.24264 2.79565 8.79565 2 8C2 9.18669 2.35189 10.3467 3.01118 11.3334C3.67047 12.3201 4.60754 13.0892 5.7039 13.5433C6.80025 13.9974 8.00665 14.1162 9.17054 13.8847C10.3344 13.6532 11.4035 13.0818 12.2426 12.2426C13.0818 11.4035 13.6532 10.3344 13.8847 9.17054C14.1162 8.00666 13.9974 6.80026 13.5433 5.7039C13.0891 4.60754 12.3201 3.67047 11.3334 3.01118C10.3467 2.35189 9.18669 2 8 2Z"
          stroke="#666666"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default DarkTheme;
